export const ACTUALIZAR_LIST_TAREA = "ACTUALIZAR_LIST_TAREA";
export const MODIFICAR_TAREA = "MODIFICAR_TAREA";
export const AGREGAR_TAREA = "AGREGAR_TAREA";  
export const ELIMINAR_TAREA = "ELIMINAR_TAREA";